query getChildCrmCompanyConfig($companyId: ID!) {
  config: getChildCrmCompanyConfig(companyId: $companyId) {
    companyId
    crmProvider
    syncModus
    isActive
    hasBeenActivated
    isUsedByUser
    enforceMasterConnection
    acceptedMasterConnection
  }
}
